import Vue from 'vue';
import Router from 'vue-router';


Vue.use(Router);

const routes = [{
    path: '/',
    redirect: '/home'
}, {
    path: '/home',
    component: () =>
        import ( /* webpackChunkName: "Home" */ '../pages/home/index.vue'),
    meta: { title: "首页" }
},{
    path: '/company',
    component: () =>
        import ( /* webpackChunkName: "Company" */ '../pages/company/index.vue'),
    meta: { title: "公司简介" }
},{
    path: '/job',
    component: () =>
        import ( /* webpackChunkName: "Job" */ '../pages/job/index.vue'),
    meta: { title: "招贤纳士" }
},{
    path: '/contact',
    component: () =>
        import ( /* webpackChunkName: "Contact" */ '../pages/contact/index.vue'),
    meta: { title: "联系我们" }
},{
    path: '/news',
    component: () =>
        import ( /* webpackChunkName: "News" */ '../pages/news/index.vue'),
    meta: { title: "新闻动态" }
},{
    path: '/news/:id',
    component: () =>
        import ( /* webpackChunkName: "News" */ '../pages/news/detail.vue'),
    meta: { title: "新闻详情" }
},{
    path: '/case',
    component: () =>
        import ( /* webpackChunkName: "Case" */ '../pages/case/index.vue'),
    meta: { title: "投资案例" }
},{
    path: '/team',
    component: () =>
        import ( /* webpackChunkName: "Team" */ '../pages/team/index.vue'),
    meta: { title: "核心团队" }
}]

const router = new Router({
    mode: 'history',
    routes: routes
})

export default router